module.exports = __webpack_public_path__ + "static/images/Bitmap.8043687.png";